import { cn } from '@/lib/utils';

import type { ReactNode } from 'react';

interface TabContentProps {
  children: ReactNode;
  className?: string;
}

export function TabContent({ children, className }: TabContentProps) {
  return (
    <div
      className={cn(
        'relative w-full max-w-3xl self-center mx-auto px-6 h-[calc(var(--main-outlet-height)-12rem)]',
        className
      )}
    >
      {children}
    </div>
  );
}
